import React from 'react';
import { IGridItem } from './types';
import { Grid } from '@material-ui/core';

/**
 * Represent the grid item of the filters
 *
 * @param {IGridItem} { children, ...props }
 */
export const GridItem = ({ children, ...props }: IGridItem) => (
    <Grid item xs={12} md={6} data-testid="grid-item" {...props}>
        {children}
    </Grid>
);
